import { connect } from 'react-redux';

import {
  getInitialChatButton,
  getIsExistingUser,
  getWidgetType,
  getUnreadMessageCount,
  getCurrentLocation,
} from 'app/modules';
import MinimizedChatButton from 'presentation/components/MinimizedChatButton';
import uiEnums from 'enums/ui';
import unminimizeWidget, { WIDGET_OPENED_TRIGGER_MANUAL } from 'actions/ui/unminimizeWidget';

//ABtesting
import { isAlternateBucket } from 'lib/handleBucketLogic';
import updateUnreadMessageCount from 'actions/messages/updateUnreadMessageCount';
import { WIDGET_TYPES } from 'enums/configuration';

export const mapStateToProps = state => {
  const widgetType = getWidgetType(state);
  const isSelfService = widgetType === WIDGET_TYPES.SELF_SERVICE || widgetType === WIDGET_TYPES.DEMO_SELF_SERVICE;
  // in the self service widget, do not clear the unread count except when the current location is CHAT
  // instead, it will be cleared when clicking on the chat with agent button
  const shouldUpdateUnreadCount = !(isSelfService && getCurrentLocation(state) !== uiEnums.LOCATIONS.CHAT);

  return {
    isExistingUser: getIsExistingUser(state),
    shouldUpdateUnreadCount,
    type: getInitialChatButton(state).type,
    unreadMessageCount: getUnreadMessageCount(state),
    value: getInitialChatButton(state).text || getInitialChatButton(state).value,
    // AB Testing, remove when experiment is over
    alternateBucket: isAlternateBucket(state.configuration.onboardingTypeTestBucket),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClick: shouldUpdateUnreadCount => {
      dispatch(unminimizeWidget(WIDGET_OPENED_TRIGGER_MANUAL));
      shouldUpdateUnreadCount && dispatch(updateUnreadMessageCount(0));
    },
    onKeyDown: shouldUpdateUnreadCount => {
      dispatch(unminimizeWidget(WIDGET_OPENED_TRIGGER_MANUAL));
      shouldUpdateUnreadCount && dispatch(updateUnreadMessageCount(0));
    },
  };
};

const MinimizedChatButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MinimizedChatButton);

export default MinimizedChatButtonContainer;
